import { Form } from 'antd';
import { useCallback, useEffect, useState } from 'react';

import type { PhoneState, PhoneValidation } from '@app/components/Phone/types';

interface UseUserContactPhoneModalParams {
  isOpen: boolean;
  initialPhone: PhoneState | null;
  isRequired: boolean;
  onSave(phone: PhoneState): void;
}

interface PhoneModalValues {
  Phone: PhoneState;
}

const EMPTY_VALIDATION: PhoneValidation = {
  isValid: true,
  errorMessage: null,
};

export const useUserContactPhoneModal = ({
  isOpen,
  initialPhone,
  isRequired,
  onSave,
}: UseUserContactPhoneModalParams) => {
  const [form] = Form.useForm<PhoneModalValues>();
  const [validation, setValidation] =
    useState<PhoneValidation>(EMPTY_VALIDATION);

  // Номер приходит после загрузки клиента, когда окно уже открыто, поэтому
  // одних initialValues мало: значение проставляется, как только оно есть.
  useEffect(() => {
    if (!isOpen) {
      setValidation(EMPTY_VALIDATION);
      return;
    }

    if (initialPhone) form.setFieldsValue({ Phone: initialPhone });
  }, [form, initialPhone, isOpen]);

  // The main phone must stay a valid number; the extra one may be cleared.
  const canSave = isRequired
    ? validation.isValid && !validation.errorMessage
    : !validation.errorMessage;

  const finishHandler = useCallback(
    ({ Phone }: PhoneModalValues) => {
      onSave(Phone);
    },
    [onSave]
  );

  const submitHandler = useCallback(() => {
    form.submit();
  }, [form]);

  return {
    form,
    canSave,
    validationHandler: setValidation,
    finishHandler,
    submitHandler,
  };
};
